import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import styles from "./index.css";
import DebounceTimer from "./DebounceTimer";

class InfoBanner extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      bounce: false,
      hide: true,
      removeFromDom: true
    };

    this.timer = new DebounceTimer({
      callback: () => {
        this.setState({
          hide: true
        });
      }
    });
  }

  componentDidMount() {
    const {
      props: { hasShownCallback }
    } = this;

    hasShownCallback();
    this.setState({
      removeFromDom: false
    });
  }

  componentWillReceiveProps({ shouldShow: nextShouldShow }) {
    const {
      state: { hide }
    } = this;

    const anotherItemHasBeenAddedToBag = !hide && nextShouldShow;

    if (anotherItemHasBeenAddedToBag) {
      this.timer.start();
      this.setState({ bounce: true });
    }
  }

  componentDidUpdate({ shouldShow: prevShouldShow }, { bounce: prevBounce }) {
    const {
      props: { shouldShow, hasShownCallback },
      state: { removeFromDom, hide, bounce }
    } = this;

    const justBounced = prevBounce && hasShownCallback && !bounce;

    if (justBounced) {
      hasShownCallback();
    }

    const isRemovedFromDomButShouldShow =
      shouldShow && removeFromDom && !prevShouldShow;

    if (isRemovedFromDomButShouldShow) {
      hasShownCallback();
      this.setState({
        removeFromDom: false
      });
    }

    const isHiddenButShouldShow = hide && prevShouldShow && !removeFromDom;

    if (isHiddenButShouldShow) {
      this.setState({
        hide: false
      });
    }

    const shouldShowDuringHideAnimation =
      shouldShow && !bounce && hide && !removeFromDom;

    if (shouldShowDuringHideAnimation) {
      hasShownCallback();
    }
  }

  finishedMoving = () => {
    const {
      props: { shouldShow },
      state: { removeFromDom, hide, bounce }
    } = this;

    if (bounce) {
      this.setState({
        bounce: false
      });
    }

    const shouldNotShowButIsRendered = !shouldShow && !removeFromDom;

    if (!hide && shouldNotShowButIsRendered && !this.timer.isTimerRunning()) {
      this.timer.start();
    }

    if (hide && shouldNotShowButIsRendered) {
      this.setState({
        removeFromDom: true
      });
    }
  };

  render() {
    const {
      props: { message, cosmeticStyles },
      state: { removeFromDom, bounce, hide }
    } = this;

    return removeFromDom ? null : (
      <div
        className={cx(
          {
            [styles.hide]: hide && !bounce,
            [styles.show]: !hide
          },
          styles.infoBannerWrapper
        )}
        onAnimationEnd={this.finishedMoving}
      >
        <div
          className={cx(
            {
              [styles.bounce]: bounce
            },
            styles.infoBanner,
            cosmeticStyles.background
          )}
          onAnimationEnd={this.finishedMoving}
        >
          <div className={cx(styles.content, cosmeticStyles.icon)}>
            <p className={styles.message}>{message}</p>
          </div>
        </div>
      </div>
    );
  }
}

InfoBanner.propTypes = {
  cosmeticStyles: PropTypes.exact({
    background: PropTypes.string,
    icon: PropTypes.string
  }),
  hasShownCallback: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  shouldShow: PropTypes.bool
};

export default InfoBanner;
